<div id="adjustment-dialog">
        <h2 mat-dialog-title>Discount Details</h2>
        <div mat-dialog-content [innerHtml]="htmlContent | dcsgSanitizeHtml"></div>
</div>
